import styled from "styled-components";
import { PickerStyleWrapper } from "../../../../../../../../components/PickerStyleWrapper";
import { GrayColors } from "@smartsuite/types";

export const Root = styled.div`
  .picker-input-field__placeholder {
    margin-left: 14px;
  }
  .picker-input-field__input {
    padding-left: 6px;
  }
  .is-clear {
    background-color: ${GrayColors["G-0-5"]};
    .picker-input-field__placeholder {
      color: ${GrayColors["G-4"]};
    }
  }
  .field-list {
    list-style: none;
    .field {
      position: relative;

      .field-deletion-btn {
        position: absolute;
        top: 2px;
        right: -22px;
        padding: 0px 4px 1px 4px;
        cursor: pointer;
      }

      &:first-child {
        .field-deletion-btn {
          display: none;
        }
      }

      &:not(:first-child) {
        margin-top: 16px;
      }
    }
  }
  .field-addition-btn {
    color: ${(props) => props.theme.primaryColor};
    font-weight: 500;
    user-select: none;
    cursor: pointer;
  }
`;

export const StyledReactInputFieldContainer = styled(PickerStyleWrapper)`
  margin: 0;
  position: relative;

  .empty-node:before {
    color: ${GrayColors["G-4"]};
  }
`;
